import { styled } from "@mui/material/styles"
import { Outlet, useLocation } from "react-router-dom"

import BackgroundImage from "../../static/images/smartsetter-glass-effect-light-v4-bg.png"
import Column from "./Column"
import Footer, { CustomerFooterRow, UserFooterRow } from "./Footer"

export default function CommonLayout() {
  const location = useLocation()
  const pagesNoSidebarRegex = new RegExp("privacy-policy|terms|ai-usage")

  return (
    <LayoutColumn>
      <Outlet />
      <Footer
        Wrapper={
          location.pathname.startsWith("/user") ||
          pagesNoSidebarRegex.test(location.pathname)
            ? UserFooterRow
            : CustomerFooterRow
        }
      />
    </LayoutColumn>
  )
}

const LayoutColumn = styled(Column)(() => ({
  position: "relative",
  minHeight: "100vh",
  backgroundImage: `url(${BackgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
}))
